import { Avatar, Box, Tooltip, tooltipClasses } from '@mui/material'
import { OnOffSwitch } from 'Components/Switch/OnOffSwitch'
import { useState } from 'react'
import { common } from '@mui/material/colors'

interface selectProps {
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
  toolTip?: string
  name: string
  disabled?: boolean
  dataTestId?: string
}

export function SwitchWithToolTip (props: selectProps): JSX.Element {
  const color = '#4591bb'
  const [open, setOpen] = useState(false)
  const handleTooltipClose = (): void => {
    setOpen(false)
  }
  const handleTooltipOpen = (): void => {
    setOpen(true)
  }

  const toolTip =
    <Tooltip
      title={props.toolTip}
      placement='top-start'
      onClose={handleTooltipClose}
      open={open}
      arrow
      PopperProps={{
        disablePortal: true,
        sx: {
          [`& .${tooltipClasses.arrow}`]: {
            color
          },
          [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: color
          }
        },
        popperOptions: {
          modifiers: [
            {
              name: 'preventOverflow',
              enabled: true,
              options: {
                altAxis: true,
                altBoundary: true,
                tether: true,
                rootBoundary: 'document',
                padding: 8
              }
            }

          ]
        }
      }}
    >
      <Box sx={{ alignContent: 'center' }}>
        <Avatar onClick={handleTooltipOpen} sx={{ bgcolor: common.black, width: '18px', height: '18px', fontSize: '15px' }}>i</Avatar>
      </Box>
    </Tooltip>

  return (
    <Box key={props.name} sx={{ display: 'contents' }} data-testid={props.dataTestId}>
      <Box sx={{ display: 'inline-flex' }}>
        <Box sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
          <OnOffSwitch
            data-testid={props.name + 'Switch'}
            name={props.name}
            value={props.checked}
            checked={props.checked}
            onChange={props.onChange}
            disabled={props.disabled}
          />
          {(props.toolTip !== undefined) && (toolTip)}
        </Box>
      </Box>
    </Box>
  )
}
